<template>
  <email-message v-if="isEmail" :message="object"></email-message>
  <sms-message v-else-if="isSms" :message="object"></sms-message>
  <internal-message v-else :message="object"></internal-message>
</template>

<script>
import {EMAIL_TYPE, INTERNAL_TYPE, SMS_TYPE} from '@/utils/MessageTypes';
import EmailMessage from '@/components/messages/EmailMessage';
import SmsMessage from '@/components/messages/SmsMessage';
import InternalMessage from '@/components/messages/InternalMessage';

export default {
  name: "MessageTimelineItem",
  components: {InternalMessage, SmsMessage, EmailMessage},
  props: [
    'object',
  ],
  computed: {
    isEmail() {
      return this.object.type === EMAIL_TYPE
    },
    isSms() {
      return this.object.type === SMS_TYPE
    },
    isInternal() {
      return this.object.type === INTERNAL_TYPE
    },
  }
}
</script>

<style scoped>

</style>
